module.exports = __webpack_public_path__ + "img/r&d_icon.07f73439.png";